import React, { useContext, useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";

// import material component
import { Box, Collapse, InputAdornment, Typography } from "@mui/material";

// import AppContext
import { AppContext } from "../../App";

// import Icons
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClockIcon from "../../assets/icons/ClockIcon";
import SearchIcon from "../../assets/icons/SearchIcon";
import ChevronDown from "../../assets/icons/ChevronDown";
import ChevronUp from "../../assets/icons/ChevronUp";


// import components
import ItemList from "../ItemList/ItemList";
import DivFlexSpaceBetween from "../DivFlexSpacebetween";
import DivFlexStart from "../DivFlexStart";
import CalendarIcon from "../../assets/icons/CalendarIcon";
import Banner from "../Banner/Banner";

// import Utils
import { getFormatDate } from "../../connector/Utils/DateUtils";
import { getTimeFormat } from "../../connector/Utils/DateUtils";
import moment from "moment";

// import Constants
import { FontFamily } from "../../Constants/FontFamily";
import { BannerVariant } from "../../Constants/BannerVariant";
import TextFieldDeliveryCardMenu from "../ReusableComponents/TextFieldDeliveryCardMenu";
import DivFlexEnd from "../DivFlexEnd";
import CloseIcon from "../../assets/icons/CloseIcon";

//import styles
import '../../index.css'
import { useTranslation } from "react-i18next";
import { getStatusChip } from "../../utils/componentHelper";

const RootDeliveryCard = styled(Box)((props) => ({
  backgroundColor: props.isDesktop
    ? props.data?.orderNumber === props.deliveryId
      ? props.theme.palette.background.deliveryCard
      : props.isOpenItemList
        ? props.theme.palette.background.deliveryCard
        : props.theme.palette.background.default
    : props.theme.palette.background.deliveryCardMenu,
  cursor: props.isDesktop
    ? props.isOpenItemList
      ? "default"
      : "pointer"
    : "pointer",
  ":hover": {
    backgroundColor: props.isDesktop
      ? props.theme.palette.variables.cardHover : undefined,
  },
  ":active": {
    backgroundColor: props.openDetail ? '' : !props.isDesktop && props.totalDelivery < 2 ? '' : props.theme.palette.background.clickedDeliveryCard,
  },
}));

const ButtonOpenOrderDetail = (props) => {
  return (
    <DivFlexEnd style={{ zIndex: 100, position: "relative", margin: "16px 24px 16px 0px" }}>
      <Typography sx={{
        fontFamily: FontFamily.PLUSJAKARTASANS,
        fontStyle: "normal",
        fontWeight: 600, fontSize: "12px",
        lineHeight: "17px",
        textDecorationLine: "underline",
        cursor: "pointer",
      }}
        onClick={props.onClick}
      >
        {props.children}
      </Typography>
    </DivFlexEnd>
  )
}

const DeliveryCard = (props) => {
  const { totalDelivery, numberOfDeliver, data, handleSearchByOrderNumberOrPositionName, isOpenItemList, deliveryId, setDeliveryId, setDetailCardOpen, scrollToTargetCard, searchBarValue } =
    props;

  const { isMobile, isTablet, isDesktop, goToDelivery } = useContext(AppContext);

  // theme color
  const theme = useTheme();

  const { t, i18n } = useTranslation();

  // local state for open itemlist
  const [openDetail, setOpenDetail] = useState(false);
  const [openItem, setOpenItem] = useState([]);

  // temporary state for old date
  const [isOldDateAvailable] = useState(true)

  const handleOpenItemList = (item) => {
    const checkData = openItem.some((v) => v === item)
    if (checkData) {
      const removedData = openItem.filter(function (value) {
        return value !== item
      })
      setOpenItem(removedData)
    }
    else {
      setOpenItem((prevState) => [...prevState, item])
    }
  }

  const handleAddAllItem = () => {
    setOpenItem("")
    const allData = []
    data.orders.map((data) => {
      return allData.push(data.orderNumber)
    })
    setOpenItem(allData);
  }

  const handleCheckItemData = () => {
    const dataLength = []
    data.orders.map((data) => {
      return dataLength.push(data.orderNumber);
    })
    if (openItem.length === dataLength.length) {
      return true
    }
    else {
      return false
    }
  }

  const handleOpenDeliveryCard = () => {
    setOpenItem([])
    // if (totalDelivery <= 1) {
    //   setOpenDetail(true)
    //   setDetailCardOpen(true)
    //   return
    // }

    if (deliveryId === data.id) {
      setDeliveryId(data.id)
      goToDelivery()
    }
    else {
      setDeliveryId(data.id)
    }
  }

  useEffect(() => {
    if (totalDelivery === 1) {
      setOpenDetail(true);
      setDetailCardOpen(true);
    } else {
      setOpenDetail(false);
      setDetailCardOpen(false);
    }
  }, [totalDelivery]);

  useEffect(() => {
    if (deliveryId === data.id) {
      setOpenDetail(true)
    }
    else {
      setOpenDetail(false)
    }
  }, [deliveryId])

  // useEffect(() => {
  //   if (deliveryId && totalDelivery > 1) {
  //     scrollToTargetCard(deliveryId)
  //   }
  // }, [openDetail])


  // data
  const timeStart = data.tourStopNotifications ? getTimeFormat(data.tourStopNotifications.actual.twStart) : null
  const timeEnd = data.tourStopNotifications ? getTimeFormat(data.tourStopNotifications.actual.twEnd) : null

  /**
   * Temporary logic for displaying ETA coming soon.
   * Might use twType later
   */
  const displayETATime = () => {
    let isComingSoon = false

    if (data.tourStopNotificationHistory) {
      isComingSoon = data.tourStopNotificationHistory.twType === 'TW_LIVE'
    }

    if (data.stopStatus === "FINISHED") {
      return `${t("deliveryFinished")} (${moment(data.stopEnd).format("HH:mm")})`
    }
    if (isComingSoon) {
      return t("comingSoon")
    }
    if (timeStart && timeEnd) {
      return `${timeStart} - ${timeEnd}`
    }

    return "-"
  }

  return (
    <RootDeliveryCard
      isDesktop={isDesktop}
      isOpenItemList={isOpenItemList}
      deliveryId={deliveryId}
      data={data}
      openDetail={openDetail}
      totalDelivery={totalDelivery}
      sx={{ width: openDetail || isDesktop ? "100%" : "calc(100% - 48px)", }}>


      <Box
        onClick={isDesktop ? undefined : () => handleOpenDeliveryCard()}
        sx={{
          padding: openDetail && !isDesktop ? "16px 24px" : (deliveryId === data.id ? "16px" : "15px"),
          boxSizing: 'border-box',
          border: ((deliveryId === data.id) || !isDesktop) ? 'none' : `1px solid ${theme.palette.variables.borderDefault}`,
          backgroundColor: (deliveryId === data.id) || !isDesktop ?
            theme.palette.background.deliveryCardMenu : 'transparent'
        }}
      >
        {(isMobile || isTablet) && (
          <>
            <DivFlexSpaceBetween>
              {openDetail && totalDelivery > 1 ? (
                <></>
              ) : (
                <DivFlexSpaceBetween sx={{ width: '100%', marginBottom: (!openDetail && !totalDelivery > 1) && isMobile ? "16px" : "10px" }}>
                  <Typography
                    fontSize={12}
                    color={theme.palette.text.primary}
                    sx={{
                      fontFamily: FontFamily.PLUSJAKARTASANS,
                      fontWeight: 400,
                      lineHeight: 'normal'
                      // lineHeight: "16.56px",
                      // fontStyle: "italic",
                    }}
                  >
                    {`${numberOfDeliver} von ${totalDelivery}`}
                  </Typography>
                  {getStatusChip(data, theme, t)}
                </DivFlexSpaceBetween>
              )}
            </DivFlexSpaceBetween>

            {(data.stopStatus === "CANCELED" && totalDelivery === 1) && (
              <Banner width={"100%"} marginBottom={'16px'} variant={BannerVariant.DANGER}>
                {t("deliveryIsCanceledPleaseWait")}
              </Banner>
            )}
          </>
        )}

        <DivFlexSpaceBetween
          sx={{ mb: isDesktop ? 0 : undefined, flexWrap: "wrap", marginTop: ((!openDetail || isDesktop) && !totalDelivery > 1) && '6px' }}
        >
          {openDetail && !isDesktop && totalDelivery > 1 ? (
            <></>
          ) : (
            <Box
              sx={{
                width: '100%'
              }}
            >
              <Box sx={{ display: isDesktop ? "block" : "none", ml: -1.2 }}>
                {getStatusChip(data, theme, t)}
              </Box>
              <Typography
                fontSize={12}
                sx={{
                  fontFamily: FontFamily.PLUSJAKARTASANS,
                  letterSpacing: "1.8px",
                  fontStyle: "normal",
                  fontWeight: 400,
                }}
                color={theme.palette.text.primary}
              >
                {`${t('tourNumber')}: ${data?.tourNumberGL} / ${data?.tripNumber}`}
              </Typography>
            </Box>
          )}
        </DivFlexSpaceBetween>
        <DivFlexSpaceBetween sx={{ marginTop: isMobile ? '4px' : '11px' }}>
          <Typography
            fontSize={14}
            color={theme.palette.text.primary}
            sx={{
              fontFamily: FontFamily.PLUSJAKARTASANSSEMIBOLD,
            }}
          >
            {data?.customerText}
            {/* {`Josef Biernoth`} */}
          </Typography>
          {/* {(isMobile || isTablet) && (
            <Box>
              {openDetail && totalDelivery > 1 ? (
                <CloseIcon sx={{
                  height: '20px',
                  width: '20px',
                  fill: theme.palette.background.deliveryCardCloseIcon
                }}
                />
              ) : (
                <></>
              )}

            </Box>
          )} */}
        </DivFlexSpaceBetween>
        {openDetail && !isDesktop && totalDelivery > 1 ? (
          <></>
        ) : (
          <>
            <DivFlexStart
              sx={{
                marginTop: '3.5px'
              }}
            >
              <Typography
                fontSize={12}
                color={theme.palette.text.primary}
                sx={{
                  fontFamily: FontFamily.PLUSJAKARTASANS,
                  // lineHeight: "16.56px",
                  fontWeight: 400,
                }}
              >
                {data.address}
              </Typography>
            </DivFlexStart>
          </>
        )}

        {openDetail && !isDesktop ? (
          <>
            {/* {isOldDateAvailable && totalDelivery > 1 && (
              <DivFlexEnd
                sx={{ pt: 0.25, pr: 2 }}
              >
                <Typography
                  fontSize={10}
                  color={theme.palette.background.iconColor}
                  sx={{
                    fontFamily: FontFamily.PLUSJAKARTASANS,
                    fontStyle: 'normal',
                    fontWeight: 300,
                    lineHeight: 'normal',
                    textDecorationLine: 'line-through'
                  }}
                >
                  Tue, 8. März 2023
                </Typography>
              </DivFlexEnd>
            )} */}

            <DivFlexSpaceBetween
              sx={{ marginTop: isOldDateAvailable && totalDelivery > 1 ? 0 : '12px' }}
            >
              <DivFlexStart>
                <Box>
                  <CalendarIcon
                    sx={{
                      fontSize: 16,
                      mr: 0.5,
                      color: data.stopStatus === 'CANCELED' && totalDelivery === 1 ?
                        theme.palette.background.iconDisabled :
                        theme.palette.background.iconColor,
                      marginTop: '3px'
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    fontSize={16}
                    color={(data.stopStatus === 'CANCELED' && totalDelivery === 1) && theme.palette.text.canceledText}
                    sx={{
                      fontFamily: FontFamily.PLUSJAKARTASANS,
                      fontWeight: 600,
                      fontStyle: "normal",
                      lineHeight: "normal",
                      textDecorationLine: (data.stopStatus === 'CANCELED' && totalDelivery === 1) && 'line-through',
                      marginTop: '6px'
                    }}
                  >
                    {getFormatDate(i18n, data.tourDate)}
                  </Typography>
                </Box>
              </DivFlexStart>

              <DivFlexStart>
                <Box>
                  <ClockIcon
                    color={(data.stopStatus === 'CANCELED' && totalDelivery === 1) ?
                      theme.palette.background.iconDisabled :
                      theme.palette.background.iconColor
                    }
                    sx={{
                      height: "16px",
                      width: "16px",
                      marginTop: '6px',
                      marginRight: "4px",
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    fontSize={16}
                    color={(data.stopStatus === 'CANCELED' && totalDelivery === 1) && theme.palette.text.canceledText}
                    sx={{
                      fontFamily: FontFamily.PLUSJAKARTASANS,
                      fontWeight: 600,
                      fontStyle: "normal",
                      lineHeight: "normal",
                      textDecorationLine: (data.stopStatus === 'CANCELED' && totalDelivery === 1) && 'line-through',
                      marginTop: '8px'
                    }}
                  >
                    {displayETATime()}
                  </Typography>
                </Box>
              </DivFlexStart>
            </DivFlexSpaceBetween>
            {(isMobile || isTablet) && (
              <Box>
                {openDetail && (
                  <>

                  </>
                )}
              </Box>
            )}
          </>
        ) : (
          <>
            {data.stopStatus === "Late" ? (
              <DivFlexStart
                sx={{ height: 14, paddingTop: isDesktop ? "8px" : "1px" }}
              >
                <Typography
                  fontSize={10}
                  sx={{
                    fontFamily: FontFamily.PLUSJAKARTASANSLIGHT,
                    textDecoration: "line-through",
                    ml: '20px',
                    color: "#8D8D8D",
                    fontWeight: 300
                  }}
                >
                  {displayETATime()}
                </Typography>
              </DivFlexStart>
            ) : (
              <DivFlexStart sx={{ height: 16 }} />
            )}

            <DivFlexStart>
              <Box>
                <CalendarIcon
                  color={theme.palette.background.iconColor}
                  sx={{
                    fontSize: 16,
                    mr: 0.5
                  }}
                />
              </Box>
              <Box>
                <Typography
                  fontSize={window.innerWidth < 1274 ? 14 : 14}
                  color={theme.palette.text.primary}
                  sx={{ fontFamily: FontFamily.PLUSJAKARTASANSSEMIBOLD, lineHeight: 0, textWrap: "nowrap" }}
                >
                  {getFormatDate(i18n, data.tourDate, true)}
                </Typography>
              </Box>
            </DivFlexStart>
            <DivFlexSpaceBetween sx={{ paddingTop: isDesktop ? "" : "1px" }}>
              <DivFlexStart sx={{ mr: 2 }}>
                <Box>
                  <ClockIcon
                    color={theme.palette.background.iconColor}
                    sx={{
                      fontSize: 16,
                      mr: 0.5
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    fontSize={window.innerWidth < 1274 ? 14 : 14}
                    color={theme.palette.text.primary}
                    sx={{ fontFamily: FontFamily.PLUSJAKARTASANSSEMIBOLD, lineHeight: 0, textWrap: "nowrap" }}
                  >
                    {displayETATime()}
                  </Typography>
                </Box>
                {data.stopStatus === "Late" ? (
                  <DivFlexStart sx={{ width: 40 }}>
                    <ArrowDropDownIcon
                      sx={{ width: 20, height: 20, color: "#da1e28" }}
                    />
                    <Typography
                      fontSize={10}
                      color={"#da1e28"}
                      sx={{
                        fontFamily: FontFamily.PLUSJAKARTASANS,
                        textTransform: "uppercase",
                        mt: 0.1,
                        fontWeight: 300,
                        lineHeight: 'normal'
                      }}
                    >
                      SPÄTE
                    </Typography>
                  </DivFlexStart>
                ) : data.stopStatus === "Early" ? (
                  <>
                    <DivFlexStart sx={{ width: 40 }}>
                      {/* <ArrowDropUpIcon sx={{ width: 20, height: 20, color: '#58d632' }} />
                            <Typography fontSize={10} color={'#31711e'} sx={{ fontFamily: FontFamily.PLUSJAKARTASANSLIGHT, textTransform: 'uppercase' }}>
                                Early
                            </Typography> */}
                    </DivFlexStart>
                    <></>
                  </>
                ) : (
                  <DivFlexStart sx={{ width: 40 }} />
                )}
              </DivFlexStart>
              {isDesktop &&
                <Typography
                  sx={{
                    fontFamily: FontFamily.PLUSJAKARTASANS,
                    fontStyle: "normal",
                    fontSize: "10px",
                    fontWeight: 300,
                    lineHeight: "13.8px",
                  }}
                >
                  {t('clickForDetails')}
                </Typography>
              }
            </DivFlexSpaceBetween>
            {isDesktop ? (
              ""
            ) : (
              <>
                {openDetail ? (
                  ""
                ) : (
                  <DivFlexSpaceBetween sx={{ marginTop: "4px" }}>
                    <DivFlexStart>
                      <CalendarIcon
                        sx={{
                          fontSize: 16,
                          mr: 0.5,
                          ml: 0.1,
                          color: theme.palette.background.iconColor,
                        }}
                      />
                      <Typography
                        fontSize={10}
                        sx={{
                          fontFamily: FontFamily.PLUSJAKARTASANS,
                          fontWeight: 300,
                          fontStyle: "normal",
                          lineHeight: "13.8px",
                        }}
                      >
                        {getFormatDate(i18n, data.tourDate)}
                      </Typography>
                    </DivFlexStart>
                    <Typography
                      fontSize={10}
                      sx={{
                        fontFamily: FontFamily.PLUSJAKARTASANS,
                        fontWeight: 300,
                        fontStyle: "normal",
                        lineHeight: "13.8px",
                      }}
                    >
                      {t('clickForDetails')}
                    </Typography>
                  </DivFlexSpaceBetween>
                )}
              </>
            )}

          </>
        )}
      </Box>

      {(isMobile || isTablet) && (
        <Box sx={{ pb: openDetail && !openItem.includes(data.orders[data.orders.length - 1]?.orderNumber) ? 5 : '' }}>
          {/* <Box>
            {openDetail && (
              <DivFlexStart sx={{ pl: 3, pr: 3 }}>
                <TextFieldDeliveryCardMenu
                  sx={{ backgroundColor: theme.palette.background.deliveryCardMenuSearchBar, width: "100%" }}
                  onChange={handleSearchByOrderNumberOrPositionName}
                  value={searchBarValue}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment sx={{ padding: "0px" }} position="start">
                        <SearchIcon color={theme.palette.background.deliverycardSearchIcon} sx={{ fontSize: 24 }} />
                      </InputAdornment>
                    )
                  }}
                  placeholder={t('searchByReceiptNumberOrItemName')} />
              </DivFlexStart>
            )}
          </Box> */}
          {handleCheckItemData() ? (
            <Box>
              {openDetail && (
                <ButtonOpenOrderDetail onClick={() => { setOpenItem([]) }}>
                  Alle verbergen
                </ButtonOpenOrderDetail>
              )}
            </Box>
          ) : (
            <Box>
              {openDetail && (
                <ButtonOpenOrderDetail onClick={() => { handleAddAllItem() }}>
                  Alle anzeigen
                </ButtonOpenOrderDetail>
              )}
            </Box>
          )}
          <Box className="deliveryCardGrid" style={{ overflowY: 'scroll', position: "relative" }}>
            {data.orders.map((order, index) => (
              <div key={index}>
                {openDetail && (
                  <Box sx={{
                    display: 'flex',
                    justifyContent: "space-between",
                    position: "sticky",
                    height: isDesktop ? "50px" : "40px",
                    alignItems: "center",
                    backgroundColor: openItem.includes(order.orderNumber) ? theme.palette.background.deliveryOrderTitleActive : '',
                    zIndex: 100,
                    top: 0,
                    borderBottom: !openItem.includes(order.orderNumber) ? `1px solid ${theme.palette.background.deliveryOrderBorderBottom}` : '',
                    padding: "0px  32px",
                    // mb: data.orders.length - 1 == index ? 5 : ''
                  }}
                    onClick={() => {
                      handleOpenItemList(order.orderNumber)
                    }}
                  >
                    <Typography sx={{
                      fontFamily: "PLUSJAKARTASANS-Regular",
                      fontStyle: "normal",
                      fontWeight: openItem.includes(order.orderNumber) ? 700 : 400,
                      fontSize: "12px",
                      lineHeight: "17px"
                    }}>
                      {`${t('receipt')} ${order.orderNumber}`}
                    </Typography>
                    {openItem.includes(order.orderNumber) ? (<ChevronUp sx={{ fontSize: 16 }} color={theme.palette.background.iconColor} />) : (<ChevronDown sx={{ fontSize: 16 }} color={theme.palette.background.iconColor} />)}
                  </Box>
                )}
                <Collapse in={openItem.includes(order.orderNumber)} sx={{ background: theme.palette.background.deliveryCardMenu }}>
                  {order.orderPositions.map((orderPosition, index) => {
                    return (
                      <ItemList
                        item={orderPosition}
                        key={index}
                        index={index}
                        itemLength={order.orderPositions.length}
                        isOpenItemList={isOpenItemList}
                      />
                    )
                  })}
                </Collapse>
              </div>
            ))}

          </Box>
        </Box>
      )}

    </RootDeliveryCard>
  );
};

DeliveryCard.defaultProps = {
  data: {
    stopStatus: "",
    stopStart: "-",
    twStart: "-",
    twEnd: "-",
    vehicle: "-",
    tourSorted: "",
    totalStops: 0,
    isCanceled: false,
    orderPositions: [0, 1, 2, 3],
    address: "-",
    customerText: "-",
    orderNumber: "-",
  },
};

export default DeliveryCard;
